import React, { useState, useEffect } from "react";
import axios from "axios";

import logo1 from "../../Assets/logos/arabian news@2x.png";
import logo2 from "../../Assets/logos/forbes@2x.png";
import logo3 from "../../Assets/logos/gulf news@2x.png";
import logo4 from "../../Assets/logos/serviced@2x.png";
import logo5 from "../../Assets/logos/khaleej times@2x.png";

const FALLBACK_LOGOS = [
  { name: "Arabian News", image: logo1, width: "w-40" },
  { name: "Forbes", image: logo2, width: "w-32" },
  { name: "Gulf News", image: logo3, width: "w-40" },
  { name: "Serviced", image: logo4, width: "w-40" },
  { name: "Khaleej Times", image: logo5, width: "w-40" },
];

const FALLBACK_TITLE = "As Featured In";

const Featured = () => {
  const [logos, setLogos] = useState(FALLBACK_LOGOS);
  const [title, setTitle] = useState(FALLBACK_TITLE);

  useEffect(() => {
    const controller = new AbortController();
    axios
      .get("https://365luxuryhomes.com/api/home-content/featured", {
        signal: controller.signal,
      })
      .then((res) => {
        if (res.data && res.data.logos && res.data.logos.length > 0) {
          setLogos(res.data.logos);
        }
        if (res.data?.title) setTitle(res.data.title);
      })
      .catch(() => {});
    return () => controller.abort();
  }, []);

  return (
    <section className="lg:py-20 md:py-14 py-10">
      <div className="container">
        <h2 className="md:text-4xl text-3xl font-bold text-center text-[#4d4b47]">
          {title}
        </h2>

        <div className="flex flex-wrap justify-center lg:justify-center gap-10 mt-10">
          {logos.map((logo, idx) => (
            <img
              key={idx}
              src={logo.image}
              alt={logo.name || ""}
              loading="lazy"
              className={`${logo.width || "w-40"} h-auto object-contain`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Featured;
